(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerWrapper = this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      
      if (this.headerIsAlwaysSticky) {
        this.classList.add('shopify-section-header-sticky');
      }

      // Add dynamic body padding adjustment
      this.adjustBodyPadding();
      window.addEventListener('resize', this.adjustBodyPadding.bind(this));
      window.addEventListener('load', this.adjustBodyPadding.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    // Function to adjust body padding based on actual header height
    adjustBodyPadding() {
      // Wait for layout to complete
      setTimeout(() => {
        const headerHeight = this.offsetHeight;
        document.body.style.paddingTop = `${headerHeight}px`;
        console.log('Applied padding-top of', headerHeight, 'px to body');
      }, 100);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Additional script to ensure body padding gets updated properly
  document.addEventListener('DOMContentLoaded', function() {
    // Initial adjustment
    adjustBodyPaddingGlobal();
    
    // Also adjust after a delay to account for any layout shifts
    setTimeout(adjustBodyPaddingGlobal, 500);
    setTimeout(adjustBodyPaddingGlobal, 1000);
  });

  function adjustBodyPaddingGlobal() {
    const header = document.querySelector('.header-wrapper');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.body.style.paddingTop = `${headerHeight}px`;
    }
  }

  // Adjust padding when window is resized
  window.addEventListener('resize', function() {
    adjustBodyPaddingGlobal();
  });



document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (toggleBtn && mobileMenu) {
    toggleBtn.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', !isOpen);
      toggleBtn.setAttribute('aria-expanded', String(!isOpen));
    });

    // Hide menu when a link is clicked
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }
});


  

  } catch(e) { console.error(e); }
})();
})();
